import React from 'react';
import { connect } from 'react-redux';

import { DataLoader } from '../../components/common';
import { LoadState } from '../../components/common/data-loader/data-loader';
import { loadCommonDataForJobsRoute } from '../../redux/actions/router/jobs-list';
import { RouterContext } from '../../types/router';

import { JobsLazyContainer } from './jobs.lazy';

interface Props {
  router?: any;
  loadCommonDataForJobsRoute(router: RouterContext): any; // Promise<any>
}

class JobsCommonDataLoader extends React.PureComponent<Props> {
  private loadCommonData(): Promise<any> {
    const { loadCommonDataForJobsRoute, router } = this.props;

    return loadCommonDataForJobsRoute(router);
  }

  public render() {
    return (
      <DataLoader loadData={this.loadCommonData.bind(this)}>
        {(props: LoadState) => <JobsLazyContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = {
  loadCommonDataForJobsRoute,
};

export const Jobs = connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(JobsCommonDataLoader);
